import { render, staticRenderFns } from "./openclass.vue?vue&type=template&id=a28c6df6&scoped=true"
import script from "./openclass.vue?vue&type=script&lang=js"
export * from "./openclass.vue?vue&type=script&lang=js"
import style0 from "./openclass.vue?vue&type=style&index=0&id=a28c6df6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28c6df6",
  null
  
)

export default component.exports